import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  createNewAccountModal: false,
  forgottenPasswordModal: false,
};
export const slice = createSlice({
  name: "signInPage",
  initialState,
  reducers: {
    setCreateNewAccountModal: (state, action) => {
      state.createNewAccountModal = action.payload;
    },
    setForgottenPasswordModal: (state, action) => {
      state.forgottenPasswordModal = action.payload;
    },
    resetSignInPage: () => initialState,
  },
});

export const { setCreateNewAccountModal, setForgottenPasswordModal } =
  slice.actions;

export const selectCreateNewAccountModal = (state) =>
  state.signInPage.createNewAccountModal;
export const selectForgottenPasswordModal = (state) =>
  state.signInPage.forgottenPasswordModal;

export default slice.reducer;
